var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      "\n    " +
        _vm._s(
          _vm.$t("notification.userPasswordChanged", {
            actor: _vm.$_.get(_vm.activity, "actorUser.name"),
            userName: _vm.$_.get(_vm.activity, "payload.userName"),
          })
        ) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }